<script>
    import { fade } from "svelte/transition";

    import CodeSelectorManualAsaProceduresSelector from "./CodeSelectorManualASAProceduresSelector.svelte";
    import {
        getAsaItemCodeLabel,
        getCardiacAdditionalProcedureQuickWins,
        updateProcedureItems,
    } from "../../../helpers/asaHelper.svelte";

    export let itemProps = {},
        defaultItems = [],
        selectedItems = [],
        updateItems = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: __default_billType_Cardiac__ =
        getCardiacAdditionalProcedureQuickWins(selectedItems);

    $: if (defaultItems.length || __default_billType_Cardiac__.length)
        _syncDefaultItems();

    $: if (selectedItems.length) _syncAdditionalItemOptions();
    else additionalItemOptions = [];

    $: selectedItemCategory = selectedItems.length
        ? selectedItems.some(({ itemCode }) => categoryOne.includes(itemCode))
            ? 1
            : selectedItems.some(({ itemCode }) =>
                    categoryTwo.includes(itemCode),
                )
              ? 2
              : 0
        : itemProps.billingType == 2
          ? itemProps.neuraxialType
          : 0;

    let itemOptions = [];

    let additionalItemOptions = [],
        displayOptionKeys = [];

    let isAllProceduresModalOpen = false;

    const __default_billType_zero__ = [
        { key: "CV025-0", value: "Art line" },
        { key: "CV014-0", value: "Art monitor" },
        { key: "CV020-0", value: "CVC Line" },
        { key: "CV014-1", value: "CVC monitor" },
        { key: "CV800-0", value: "US for vascular access" },
        { key: "CV081-0", value: "Major nerve block" },
        { key: "CV083-0", value: "Major nerve block with catheter" },
        { key: "CV082-0", value: "Minor nerve block" },
        { key: "CV805-0", value: "US for nerve block" },
        { key: "CV084-0", value: "Eye block" },
        { key: "CV085-0", value: "Neuraxial analgesia (initial)" },
        { key: "CV086-0", value: "Neuraxial analgesia (top-up)" },
        { key: "CV007-0", value: "Fibreoptic intubation" },
        { key: "CV008-0", value: "Lung isolation" },
        { key: "CV002-0", value: "Blood Transfusion" },
        { key: "CV003-0", value: "Massive blood transfusion" },
        { key: "CV001-0", value: "Blood collection" },
        { key: "CV009-0", value: "EEG monitor" },
    ];

    const __default_billType_one__ = [
        { key: "CV125-0", value: "Regional top up < 15m" },
        { key: "CV126-0", value: "Regional top up > 15m" },
        { key: "CV003-0", value: "Cannulation & Transfusion" },
        { key: "BL600-0", value: "CVC" },
        { key: "BL690-0", value: "Airway access" },
        { key: "BL640-0", value: "Art line" },
    ];

    const __default_billType_two__ = [
        { key: 1, value: "Insertion" },
        { key: 2, value: "Top up | Revision" },
    ];

    const categoryOne = ["CV120", "CV122", "CV123", "CV124"];
    const categoryTwo = ["CV125", "CV126"];

    export const handleSelectItem = (item, isFromQuickWin = true) => {
        const { billingType } = itemProps;
        const needUpdateNeuraxialType = billingType == 2;

        if (isFromQuickWin) {
            if (needUpdateNeuraxialType) {
                itemProps.neuraxialType = itemProps.neuraxialType
                    ? itemProps.neuraxialType == item?.key
                        ? 0
                        : (item.key ?? 0)
                    : (item.key ?? 0);
            }
        }

        updateItems(
            updateProcedureItems(item, selectedItems, itemProps, defaultItems),
        );
    };

    // HELPER FUNCTIONS
    const _syncDefaultItems = () => {
        itemOptions = [];

        const { billingType } = itemProps;

        if (billingType != 2) {
            const mapArr =
                billingType == 0
                    ? __default_billType_zero__
                    : billingType == 1
                      ? __default_billType_one__
                      : billingType == 3
                        ? __default_billType_Cardiac__
                        : [];

            mapArr.map((item) => {
                const { key, value } = item;

                const targetItem = defaultItems.find((dItem) => {
                    const combinedKey = `${dItem.itemCode}-${dItem.subItemCode}`;

                    return key == combinedKey;
                });

                if (targetItem)
                    itemOptions.push({
                        ...targetItem,
                        combinedKey: key,
                        value,
                    });
                else itemOptions.push({ value: "" });
            });
        } else itemOptions = [...__default_billType_two__];
    };

    const _syncAdditionalItemOptions = () => {
        // NOW consider billingType 0 & 1
        // billingType 2 does NOT support select other additional items exclude INSERTION and TOP-UP
        // billingType 3 NOT implemented yet
        const { billingType } = itemProps;

        additionalItemOptions = [];

        if (!displayOptionKeys.length) {
            if (billingType == 0)
                __default_billType_zero__.map((opt) =>
                    displayOptionKeys.push(opt.key),
                );
            else if (billingType == 1)
                __default_billType_one__.map((opt) =>
                    displayOptionKeys.push(opt.key),
                );
            else if (billingType == 3)
                __default_billType_Cardiac__.map((opt) =>
                    displayOptionKeys.push(opt.key),
                );
        }

        const selectedAPItems = selectedItems
            .filter((item) => item.infoType == "AdditionalProcedures")
            .map((item) => ({
                ...item,
                key: `${item.itemCode}-${item.subItemCode}`,
            }));

        if (!selectedAPItems.length) return;

        selectedAPItems.map((item) => {
            if (!displayOptionKeys.includes(item.key))
                additionalItemOptions.push(item);
            else
                additionalItemOptions = additionalItemOptions.filter(
                    (itm) => itm.key != item.key,
                );
        });
    };

    const _openAllProcedureModal = () => (isAllProceduresModalOpen = true);

    const _closeAllProcedureModal = () => (isAllProceduresModalOpen = false);

    const _getLabelFromCombinedKey = (combinedKey) => {
        if (!combinedKey) return "";

        const [itemCode, subItemCode] = combinedKey.split("-");

        return getAsaItemCodeLabel({ itemCode, subItemCode });
    };
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    <div class="flex flex-1 items-center justify-between">
        <p class="font-bold text-lg">Additional Procedures</p>

        {#if itemProps.billingType != 2}
            <button
                class="btn btn-sm btn-secondary"
                on:click|preventDefault={_openAllProcedureModal}
            >
                View all
            </button>
        {/if}
    </div>
    {#if itemOptions.length}
        <div class="grid grid-cols-2 w-full gap-4">
            {#each itemOptions as item}
                {#if item.value}
                    <button
                        class={`btn btn-sm rounded rounded-full hover:btn-primary text-xs ${
                            itemProps.billingType == 2
                                ? itemProps.neuraxialType == 3
                                    ? "btn-primary"
                                    : itemProps.neuraxialType == item.key
                                      ? "btn-primary"
                                      : "btn-secondary"
                                : selectedItems.some(
                                        (itm) =>
                                            itm.itemCode == item.itemCode &&
                                            itm.subItemCode == item.subItemCode,
                                    )
                                  ? "btn-primary"
                                  : "btn-secondary"
                        }`}
                        on:click|preventDefault={() => handleSelectItem(item)}
                    >
                        {itemProps.billingType == 2
                            ? ""
                            : `${_getLabelFromCombinedKey(item.combinedKey)}`}
                        {item.value}
                    </button>
                {:else}
                    <div />
                {/if}
            {/each}
        </div>
        <div class="divider" style="margin-top: 0px; margin-bottom: 0px;"></div>
    {/if}
    <div class="grid grid-cols-2 w-full gap-4">
        {#each additionalItemOptions as item}
            <button
                class={`btn btn-sm rounded rounded-full hover:btn-primary text-xs} ${
                    selectedItems.some(
                        (itm) =>
                            itm.itemCode == item.itemCode &&
                            itm.subItemCode == item.subItemCode,
                    )
                        ? "btn-primary"
                        : "btn-secondary"
                }`}
                on:click|preventDefault={() => handleSelectItem(item, false)}
            >
                {getAsaItemCodeLabel(item)}
                {item.infoShortTitle}
            </button>
        {/each}
       
    </div>
</div>

<CodeSelectorManualAsaProceduresSelector
    isModalOpen={isAllProceduresModalOpen}
    {defaultItems}
    {selectedItems}
    addItem={handleSelectItem}
    closeModal={_closeAllProcedureModal}
/>
